<script setup lang="ts">
import {IconWarning} from "@iconify-prerendered/vue-carbon"
import { useOnline } from '@vueuse/core'

const online = useOnline()
</script>

<template>
  <div v-if="!online" class="absolute top-0 left-0 w-full h-full backdrop-blur-sm bg-white/30 text-center">
    <div class="flex justify-center items-center w-full h-full text-[#f00]">
      <IconWarning class="w-20 h-20"/> Bad network connection
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>